import {
  Storage,
  INIT,
  SET_ITEM,
  REMOVE_ITEM,
} from 'app/models/sessionStorage/constants';
import { storageReducers } from 'app/models/storage/reducers';

export const sessionStorageReducers = storageReducers(
  Storage,
  INIT,
  SET_ITEM,
  REMOVE_ITEM,
);
